export default function ProgrammeNavigation(days) {

    return `

        <aside class="programme-navigation">

            ${days.map(day => `

                <a href="#day-${day.id}">

                    ${day.title}

                </a>

            `).join('')}

        </aside>

    `;

}
